import { render } from "./BannerFormModal.vue?vue&type=template&id=1f088ab6"
import script from "./BannerFormModal.vue?vue&type=script&lang=js"
export * from "./BannerFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__